import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const FLEET_VEHICLE_EXPENSE_EDIT_FORM_SCHEMA = yup.object().shape({
  expenseTypeId: yup
    .string()
    .required("Molimo Vas da odaberite tip troška"),
  name: yup.string().required("Molimo Vas da unesete naziv"),
  amount: yup.string().required("Molimo Vas da unesete iznos troška"),
  taxAmount: yup.string().required("Molimo Vas da unesete iznos poreza"),
});
